import { render, staticRenderFns } from "./HelpView.vue?vue&type=template&id=72622545&scoped=true"
import script from "./HelpView.vue?vue&type=script&lang=js"
export * from "./HelpView.vue?vue&type=script&lang=js"
import style0 from "./HelpView.vue?vue&type=style&index=0&id=72622545&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72622545",
  null
  
)

export default component.exports